<template>
   <div class="  is-fullheight sticky-sidebar" >
     <aside class="menu column  aside   is-fullheight" >
      <p class="menu-label">
        Printing/Cutting
      </p>
      <ul class="menu-list">
        <li>
          <a class="">Overview</a>
          <ul>
            <li @click="activeMenuLink = 'printing-cutting/overview'"><router-link to="/printing-cutting/overview"  :class="{'is-active':activeMenuLink === 'printing-cutting/overview'}">Overview</router-link></li>
            <li @click="activeMenuLink = 'printing-cutting/view-order'"><router-link to="/printing-cutting/view-order"  :class="{'is-active':activeMenuLink === 'printing-cutting/view-order'}">Find an Order</router-link></li>
            <li @click="activeMenuLink = 'printing-cutting/scheduler'"><router-link to="/printing-cutting/scheduler"  :class="{'is-active':activeMenuLink === 'printing-cutting/scheduler'}">Scheduler</router-link></li>
            <li @click="activeMenuLink = 'printing-cutting/planner'"><router-link to="/printing-cutting/planner"  :class="{'is-active':activeMenuLink === 'printing-cutting/planner'}">Print Planner</router-link></li>
            
          </ul>
        </li>
        <li>
          <a class="">Areas</a>
          <ul>
            <li @click="activeMenuLink = 'printing-cutting/printing-paper'"><router-link to="/printing-cutting/printing-paper"  :class="{'is-active':activeMenuLink === 'printing-cutting/printing-paper'}">Printing Paper</router-link></li>
            <li @click="activeMenuLink = 'printing-cutting/printing-rolls'"><router-link to="/printing-cutting/printing-rolls"  :class="{'is-active':activeMenuLink === 'printing-cutting/printing-rolls'}">Printing Rolls (Trans)</router-link></li>
            <li @click="activeMenuLink = 'printing-cutting/cutting'"><router-link to="/printing-cutting/cutting"  :class="{'is-active':activeMenuLink === 'printing-cutting/cutting'}">Cutting (Gerber)</router-link></li>
            <li @click="activeMenuLink = 'printing-cutting/multiply-cutting'" ><router-link to="/printing-cutting/multiply-cutting"  :class="{'is-active':activeMenuLink === 'printing-cutting/multiply-cutting'}">Cutting (Multi-Ply)</router-link></li>
            <li @click="activeMenuLink = 'printing-cutting/awaiting-makeup'"><router-link to="/printing-cutting/awaiting-makeup"  :class="{'is-active':activeMenuLink === 'printing-cutting/awaiting-makeup'}">Awaiting Makeup</router-link></li>
            <li @click="activeMenuLink = 'printing-cutting/multiply-awaiting-makeup'" ><router-link to="/printing-cutting/multiply-awaiting-makeup"  :class="{'is-active':activeMenuLink === 'printing-cutting/multiply-awaiting-makeup'}">Multi-Ply Awaiting Makeup</router-link></li>
            
          </ul>
        </li>

        <li>
          <a class="">Reports</a>
          <ul>
            <li @click="activeMenuLink = 'reports/printing-cutting-summary'"><router-link to="/reports/printing-cutting-summary"  :class="{'is-active':activeMenuLink === 'reports/printing-cutting-summary'}">Summary Report</router-link></li>
            <li @click="activeMenuLink = 'reports/printing-processed-report'"><router-link to="/reports/printing-processed-report"  :class="{'is-active':activeMenuLink === 'reports/printing-processed-report'}">Processed Report</router-link></li>
             
          </ul>
        </li>
        
        <li>
          <a class="">Data Input</a>
          <ul>
            <li @click="activeMenuLink = 'printing-cutting/data-input'"><router-link to="/printing-cutting/data-input"  :class="{'is-active':activeMenuLink === 'printing-cutting/data-input'}">Factory Floor</router-link></li>
            
          </ul>
        </li>
        
        
      </ul>

      
      
    </aside>
    
   </div>
</template>

<script>
import OrderMixin from "@/mixins/OrderMixin.js";

export default {
  name: 'SideBarPrintingCutting',
  components: {
  },
  mixins: [OrderMixin],
  data() {
    return { 
      activeMenuLink: null,
      user: {tasks: []},
     }
  },
  mounted() {
    this.activeMenuLink = this.$route.path.substring(1)
    console.log(this.$route.path)
  },
  created() {
		this.getAccessToken()
        .then(() => { 
           this.getUserProfile(1); // 1 for with_tasks
        });
	}
}

</script>



